<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-20 15:50:07
 * @LastEditors: mrh
 * @LastEditTime: 2020-09-28 14:42:46
--> 
<template>
  <div class="success">
    <i class="icon-jinduquerentubiao iconfont"></i>
    <span>您已成功提交申请，请留意短信通知</span>
    <van-button
      color="linear-gradient(to right, #ff6034, #ee0a24)"
      @click="returnBack()"
    >返回首页</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    returnBack() {
      // 悦买端返回首页、店长端返回登录页
      if (this.$store.getters.ambientType == 0) {
        this.pathType == 1 ? wx.miniProgram.switchTab({ url: "/pages/bazaarIndex/bazaarIndex" }) : wx.miniProgram.navigateBack({ delta: 9999 })
      } else if (this.$store.getters.ambientType == 1) {
        this.pathType == 1 ? window.Android.goAppIndex() : window.Android.jumpLogin()
      } else if (this.$store.getters.ambientType == 2) {
        this.pathType == 1 ? window.webkit.messageHandlers.goAppIndex.postMessage("") : window.webkit.messageHandlers.jumpLogin.postMessage("")
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.success {
  display: flex;
  flex-flow: column;
  align-items: center;
  i {
    color: #4ecb74;
    font-size: 81px;
    margin-top: 170px;
  }
  > span {
    font-size: 16px;
    color: #333333;
    margin-top: 30px;
  }
  .van-button {
    width: 355px;
    height: 44px;
    border-radius: 25px;
    position: fixed;
    bottom: 20px;
  }
}
</style>

